/* -------------------------------------------------------------------------------------
This module manages all API calls. It creates an axios object called apiClient which 
performs all API calls. 

The code for the API itself is located here: C:\Users\danie\_tourdb\tourdb_api.
The source code is located here: https://github.com/leuti/tourdb_api.git.

--> ACTION: implement user specific calls for participants (select only parts belonging to user)
--> ACTION: find a solution that hack for reached flag is not required anymore
---------------------------------------------------------------------------------------*/
//require('dotenv').config() // include .env file

import axios from 'axios' // import the axios module

// create apiClient with default parameters
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
  //crossdomain: true
})

export default {
  deleteTrack(trackId) {
    // delete given track in DB
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.delete('/tracks?userid=' + userid + '&trackId=' + trackId)
  },

  deleteParticipant(participantId) {
    // delete given participant in DB
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.delete(
      '/participants?userid=' + userid + '&participantId=' + participantId
    )
  },

  deleteWaypoint(waypId) {
    // delete given record in DB
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.delete(
      '/waypoints?userid=' + userid + '&waypointId=' + waypId
    )
  },

  evalTouchedAreas(track) {
    // evaluate touched area based on track coordinates
    setAuthHeader()
    return apiClient.post('/trackareas', track)
  },

  getAreas() {
    // retrieve all records from table areas - not user specific
    setAuthHeader()
    return apiClient.get('/areas')
  },

  getGrades() {
    // retrieve all records from table grades - not user specific
    setAuthHeader()
    return apiClient.get('/grades')
  },

  getParticipants() {
    // retrieve specific record from table participants - selection is user specific (not yet implemented)
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.get('/participants?userid=' + userid)
  },

  getParticipantsStats() {
    // get track per period stats
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.get('/participants/participantsStats?userid=' + userid)
  },

  getTags() {
    // retrieve specific record from table tags
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.get('/tags?userid=' + userid)
  },

  getTypes() {
    // retrieve all records from table types - not user specific
    setAuthHeader()
    return apiClient.get('/types')
  },

  getTrack(id) {
    // retrieve specific record from table tracks - selection is user specific
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.get('/tracks/' + id + '?userid=' + userid)
  },

  getTracks(approvingUsers, approvedParts) {
    // retrieve  records from table tracks (using paging) - selection is user specific
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.get(
      '/tracks?userid=' +
        userid +
        '&approvingUsers=' +
        approvingUsers +
        '&approvedParts=' +
        approvedParts
    )
  },

  getTrackParts(id) {
    // retrieve specific record from table trackparts - user specific as bound to track id
    setAuthHeader()
    return apiClient.get('/trackparts/' + id)
  },

  getWaypointsList() {
    // get track per period stats
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.get('/waypoints/waypointsList?userid=' + userid)
  },

  getWaypointsPerTrack() {
    // get track per period stats
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.get('/waypoints/waypointsPerTrack?userid=' + userid)
  },

  insertParticipant(participant) {
    // insert given participant in DB
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.post('/participants?userid=' + userid, participant)
  },

  insertTrack(track) {
    // insert given track in DB
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.post('/tracks?userid=' + userid, track)
  },

  insertWaypoint(wayp) {
    // insert given wayp in DB
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.post('/waypoints?userid=' + userid, wayp)
  },

  getTracksKmlFiltered(trackIds, format) {
    // get track points for given track Ids
    const userId = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.get('/tracksKml', {
      params: { userId: userId, trackIds: JSON.stringify(trackIds), format: format }
    })
  },

  getTracksKmlInitial(params) {
    // get track points for initial display (selection defined in API)
    const userId = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.get('/tracksKml', {
      params: { userId: userId, trackIds: JSON.stringify(params.trackIds), limit: params.limit, format: params.format }
      })
  },

  getTrackWayps(id) {
    // retrieve specific record from table trackwayps - user specific as bound to track id
    setAuthHeader()
    return apiClient.get('/trackwayps/' + id)
  },

  getWaypoints() {
    // retrieve all records from table waypoints - not user specific
    setAuthHeader()
    return apiClient.get('/waypoints')
  },

  updateEmail(id, email) {
    // update the participant data
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.put(
      '/users/email/' + id + '?userid=' + userid + '&email=' + email
    )
  },

  updateParticipant(id, participant) {
    // update the participant data
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.put(
      '/participants/' + id + '?userid=' + userid,
      participant
    )
  },

  updatePassword(id, password) {
    // update the participant data
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.put(
      '/users/password/' + id + '?userid=' + userid + '&password=' + password
    )
  },

  updateTrack(id, track) {
    // update the track data
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.put('/tracks/' + id + '?userid=' + userid, track)
  },

  updateTrackPart(id, trackparts) {
    // update the trackparts data
    setAuthHeader()
    return apiClient.post('/trackparts/' + id, trackparts)
  },

  updateTrackWayp(id, trackwayps) {
    // update the trackwayps data
    setAuthHeader()

    // the following secion is implemented because the reached attribute is set to false in the vuex bindings of TrackUI, while it is set to 0 in the state
    // ACTION: find a solution that this section is not required anymore
    let newTrackwayps = []
    trackwayps.forEach(function(record) {
      if (record.reached == false) {
        newTrackwayps.push({
          id: record.id,
          reached: 0
        })
      } else {
        newTrackwayps.push({
          id: record.id,
          reached: 1
        })
      }
    })
    // end of hack sequence

    return apiClient.post('/trackwayps/' + id, newTrackwayps)
  },
  updateUser(id, user) {
    // update the participant data
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.put('/users/' + id + '?userid=' + userid, user)
  },

  updateWayp(id, wayp) {
    // update the waypoint data
    const userid = JSON.parse(localStorage.getItem('user')).id
    setAuthHeader()
    return apiClient.put('/waypoints/' + id + '?userid=' + userid, wayp)
  },

  userLogin(credentials) {
    // check if delivered login credentials are valid; if yes return token
    setAuthHeader()
    return apiClient.post('/login', credentials)
  },

  userRegister(credentials) {
    // register user if not yet existing and return token
    setAuthHeader()
    return apiClient.put('/register', credentials)
  }
}

function setAuthHeader() {
  // Set the appropriate token in the Authorisation header
  const authUser = localStorage.user ? JSON.parse(localStorage.user) : ''
  apiClient.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${authUser.token}`
}
